import React, { useState, useEffect } from 'react';
import { storyAPI } from '../services/api';

const Story = () => {
    const [story, setStory] = useState([]);
    const [lang, setLang] = useState('en');
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        loadStory();
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const loadStory = async () => {
        try {
        const response = await storyAPI.getAll();
        setStory(response.data);
        setLoading(false);
        } catch (error) {
        console.error('Error loading story:', error);
        setLoading(false);
        }
    };

    if (loading) return <div style={styles.loading}>Cargando...</div>;

    return (
        <section style={isMobile ? {...styles.section, ...styles.sectionMobile} : styles.section}>
        <div style={styles.container}>
            <div style={styles.header}>
            <h2 style={isMobile ? {...styles.title, ...styles.titleMobile} : styles.title}>STORY</h2>
            <button 
                onClick={() => setLang(lang === 'en' ? 'es' : 'en')}
                style={styles.langButton}
            >
                {lang === 'en' ? 'ES' : 'EN'}
            </button>
            </div>
            
            <div style={styles.content}>
            {story.map((section, index) => (
                <div 
                  key={section.id} 
                  style={isMobile ? {...styles.storySection, ...styles.storySectionMobile} : styles.storySection}
                >
                <div style={index % 2 === 0 ? styles.imageLeft : styles.imageRight}>
                    <div style={styles.storyImage}>
                    {section.imageUrl ? (
                        <img src={section.imageUrl} alt="Story" style={styles.image} />
                    ) : (
                        <div style={styles.imagePlaceholder}>Image</div>
                    )}
                    </div>
                </div>
                <div style={styles.storyText}>
                    <p style={isMobile ? {...styles.text, ...styles.textMobile} : styles.text}>
                    {lang === 'es' ? section.textEs : section.textEn}
                    </p>
                </div>
                </div>
            ))}
            </div>
        </div>
        </section>
    );
};

const styles = {
    section: {
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #000 0%, #1a1a1a 100%)',
        padding: '100px 2rem 4rem',
        fontFamily: 'Roboto, sans-serif',
    },
    sectionMobile: {
        padding: '80px 1rem 2rem',
    },
    container: {
        maxWidth: '1000px',
        margin: '0 auto',
        fontFamily: 'Roboto, sans-serif',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '3rem',
        fontFamily: 'Roboto, sans-serif',
    },
    title: {
        fontSize: '3rem',
        color: '#fff',
        letterSpacing: '0.3rem',
        fontFamily: 'Roboto, sans-serif',
    },
    titleMobile: {
        fontSize: '2rem',
        letterSpacing: '0.15rem',
    },
    langButton: {
        padding: '0.5rem 1.5rem',
        background: '#222',
        border: 'none',
        color: '#fff',
        cursor: 'pointer',
        borderRadius: '5px',
        fontFamily: 'Roboto, sans-serif',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4rem',
        fontFamily: 'Roboto, sans-serif',
    },
    storySection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2.5rem',
        background: 'rgba(255,255,255,0.02)',
        borderRadius: '18px',
        padding: '2.5rem 2rem',
        border: '1px solid rgba(255,255,255,0.06)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
        transition: 'transform 0.4s ease, box-shadow 0.4s ease',
        fontFamily: 'Roboto, sans-serif',
    },
    storySectionMobile: {
        padding: '1.5rem 1rem',
        gap: '1.5rem',
    },
    imageLeft: {
        order: 1,
    },
    imageRight: {
        order: 2,
    },
    storyImage: {
        width: '100%',
        aspectRatio: '21 / 9',
        background: '#222',
        borderRadius: '10px',
        overflow: 'hidden',
        fontFamily: 'Roboto, sans-serif',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        fontFamily: 'Roboto, sans-serif',
    },
    imagePlaceholder: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#666',
        fontFamily: 'Roboto, sans-serif',
    },
    storyText: {
        order: 2,
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Roboto, sans-serif',
    },
    text: {
        fontSize: '1.1rem',
        lineHeight: '1.8',
        color: '#ccc',
        whiteSpace: 'pre-line',
        maxWidth: '700px',
        textAlign: 'center',
        fontFamily: 'Roboto, sans-serif',
    },
    textMobile: {
        fontSize: '0.95rem',
        lineHeight: '1.6',
        maxWidth: '100%',
    },
    loading: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '1.5rem',
        fontFamily: 'Roboto, sans-serif',
    },
};

export default Story;
